<template>
  <div>
    <!-- [개편 주석 처리]
    <transition name="lnb-background-transition" enter-active-class="fadeIn" leave-active-class="fadeOut">
      <div class="lnb-side-cover lnb-cover-duration" v-if="lnbStatus" @click="closeLnb"></div>
    </transition>
    -->
    <transition name="lnb-slide-transition" enter-active-class="slideInLeft" leave-active-class="slideOutLeft">
      <lnb-slide-menu v-if="lnbStatus" class="lnb-slide-duration" :show-user-info="showUserInfo"></lnb-slide-menu>
    </transition>
    <transition name="user-info-modify-transition" enter-active-class="slideInRight" leave-active-class="slideOutRight">
      <div data-scroll-element="true" v-if="isVisibleAlarms" class="lnb-slide-duration alarm-scroll-wrapper">
        <Alarms />
      </div>
    </transition>
  </div>
</template>

<script>
import LnbSlideMenu from '@/components/lnb/LnbSlideMenu'
import Alarms from '@/views/lnb/Alarms'
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'LnbWrapper',
  components: {
    LnbSlideMenu,
    Alarms
  },
  computed: {
    ...mapGetters([ 'lnbStatus', 'isVisibleAlarms' ])
  },
  methods: {
    ...mapMutations({
      showLnb: 'showLnb',
      showUserProfile: 'showUserProfile',
      hideUserProfile: 'hideUserProfile',
      hideLnb: 'hideLnb'
    }),
    showUserInfo () {
      this.hideLnb()
      this.showUserProfile()
    },
    closeUserInfo () {
      this.hideUserProfile()
    },
    closeLnb (e) {
      this.hideLnb()
    }
  }
}
</script>

<style scoped>
  .alarm-scroll-wrapper {
    position: absolute;
    width: 100%;
    height: 100%;
    top:0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #fff;
    z-index:6000;
  }
  .lnb-cover-duration {
    animation-duration: 300ms;
  }
</style>
